<template>
<div class="chapter">
<div class="inner_page">
<h3 class="ChTitle" id="ch17"><a id="ch17a"></a><a id="page_41"></a><a href="#/Contents#rch17"><span class="underline">MR. BASEBALL</span></a></h3>
<p class="center1"><span><i>After a lackluster baseball career, Bob Uecker became an actor, sports broadcaster, and TV personality. And he’s funny about it all, too.</i></span></p>
<p class="noindent"><span>“I helped the Cardinals win the pennant. I came down with hepatitis.”</span></p>
<p class="noindent1a"><span>“I signed with the Milwaukee Braves for $3,000. That bothered my dad because he didn’t have that kind of dough, but he eventually scraped it up.”</span></p>
<p class="noindent1a"><span>“When I came up to bat with three men on and two outs in the ninth, I looked in the other team’s dugout, and they were already in street clothes.”</span></p>
<p class="noindent1a"><span>“I go to a lot of Old Timers games, and I haven’t lost a thing. I sit in the bullpen and let people throw things at me. Just like old times.”</span></p>
<p class="noindent1a"><span>“I led the league in ‘Go get ’em next time.’”</span></p>
<p class="noindent1a"><span>“If a guy hits .300 every year, what does he have to look forward to? I always tried to stay around .190, with three or four RBI. And I tried to get them all in September. That way I always had something to talk about during the winter.”</span></p>
<p class="noindent1a"><span>“I knew when my career was over. In 1965 my baseball card came out with no picture.”</span></p>
<p class="noindent1a"><span>“The biggest thrill a ballplayer can have is when your son takes after you. That happened when my Bobby was in his championship Little League game. Struck out three times. Gosh, I was proud.”</span></p>
<p class="noindent1a"><span>“When I looked to the third-base coach for a sign, he turned his back on me.”</span></p>
<p class="noindent1a"><span>“I had slumps that lasted into the winter.”</span></p>
<p class="noindent1a"><span>“The highlight of my career? In ’67 with St. Louis, I walked with the bases loaded to drive in the winning run in an intersquad game in spring training.”</span></p>
<p class="noindent1a"><span>“I won the Comeback of the Year Award five years in a row.”</span></p>
<p class="noindent1a"><span>“I set records that will never be equaled. In fact, I hope 90 percent of them don’t even get printed.”</span></p>
<div class="box">
<p class="center7"><span><b>Seeing the color red can make your heart beat faster.</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter017.vue?f231eb40